import { pageEntry } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";

export const entrypoints = [pageEntry("pessoas", designCopy.lugares.pessoas, () => import("./view.tsx"))];
